import { render } from "./tuishuishezhi.vue?vue&type=template&id=94c5f6f4&scoped=true"
import script from "./tuishuishezhi.vue?vue&type=script&lang=js"
export * from "./tuishuishezhi.vue?vue&type=script&lang=js"

import "./tuishuishezhi.vue?vue&type=style&index=0&id=94c5f6f4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94c5f6f4"]])

export default __exports__